import React from 'react';
import SubViewOptions from '../../SubViewOptions';
import SearchSimple from '../../../../../../../components/SearchSimples/SearchSimple';
import CustomTable from '../../../../../../../components/table/CustomTable';
import GlobalTableApp from '../Functionality/GlobalTableApp';
import { permissionObj } from '../../../../../../../Helpers/permission';
import CustomButtonLink from '../../../../../../../components/buttons/CustomButtonLink';
import DeleteModal from '../../../../../../Modals/DeleteModal';
import ConfirmModal from "../../../../../Visitor/Invitation/Modal/ConfirmModal";
import { STATUS_MODEL } from '../../../../../../../enums/statusEnum';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const GlobalTable = ({
    subView,
    changeSubViewManage,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    modified,
    setModified,
    registerAction,
    activeStep,
    selectForDelete,
    setSelectForDelete,
}) => {

    const {
        t,
        DEV,
        permission,
        results,
        setResults,
        rowsPerPage,
        tableId,
        searchId,
        thead,
        tbody,
        pagination,
        getActionsButtons,
        deleteModalShow,
        selectedItem,
        handleDeleteModalClose,
        handleDeleteSelected,
        handleCreate,
        showActiveInactiveModal,
        setShowActiveInactiveModal,
        handleStatusChange,
        handleDragEnd,
        canUpdate,
        canCreate
    } = GlobalTableApp({
        searchElement,
        setBodyForExport,
        option,
        modified,
        setModified,
        registerAction,
        activeStep,
        subView,
        selectForDelete,
        setSelectForDelete,
    });

    return (
        <>
            <div className='d-flex mb-4'>
                <SubViewOptions subView={subView} changeSubViewManage={changeSubViewManage} />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        search={search}
                        setSearch={setSearch}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        contractorId={null}
                        supplierId={null}
                    />
                </div>
            </div>

            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                selectedList={selectForDelete}
                thead={thead}
                tbody={tbody}
                columnActions={true}
                getActionsButtons={getActionsButtons}
                sortable={!!canUpdate}
                onDragEnd={canUpdate ? handleDragEnd : undefined}
                childrenNotInformation={
                    tbody?.data?.length === 0 ? (
                        <>
                            <div className='warning-text'>
                                <p>{t('you_haven_not_created_any_global_payroll_policies_yet')}</p>
                            </div>
                            {canCreate && (
                                <CustomButtonLink
                                    splitName={false}
                                    id='btn_gt_add_global_rule'
                                    card={true}
                                    onClick={handleCreate}
                                    name='add_global_rule'
                                />
                            )}
                        </>
                    ) : undefined
                }
            />
            {pagination()}

            {deleteModalShow && (
                <DeleteModal
                    show={deleteModalShow}
                    onHide={handleDeleteModalClose}
                    onClickFn={handleDeleteSelected}
                    data={selectedItem ? [selectedItem] : results.content.filter(r => selectForDelete.includes(r.id))}
                    title_modal={t('delete_global_policy')}
                    description='are_you_sure_you_want_to_delete'
                    element_modal={t('global_policy')}
                    buttonCancelText='cancel'
                />
            )}

            <ConfirmModal
                show={showActiveInactiveModal}
                onHide={() => setShowActiveInactiveModal(false)}
                onClickFn={handleStatusChange}
                title_modal={parseInt(selectedItem?.statusId) === STATUS_MODEL.ACTIVE_COMPANY ? 'deactivate_policy' : 'activate_policy'}
                description={parseInt(selectedItem?.statusId) === STATUS_MODEL.ACTIVE_COMPANY
                    ? t('are_you_sure_you_want_to_deactivate_the_policy')
                    : t('are_you_sure_you_want_to_activate_the_policy')}
            />
        </>
    );
};

export default GlobalTable;
